import gql from 'graphql-tag';

export const NAME = 'compositions_UserRole_query';

export default gql`
  query ${NAME} {
    currentUserProfile {
      role {
        name
        permissions
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/features/rbac/withUserRole/userRoleQuery.js